import script from "./GestaoWorkflowProcessos_76.vue?vue&type=script&setup=true&lang=js"
export * from "./GestaoWorkflowProcessos_76.vue?vue&type=script&setup=true&lang=js"

import "./GestaoWorkflowProcessos_76.vue?vue&type=style&index=0&id=85aaf090&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85aaf090"]])

export default __exports__